<!-- INFO: Original Component: src\components\cart\CartItem.vue -->
<!-- eslint-disable @typescript-eslint/no-explicit-any -->
<template>
  <div class="grid grid-cols-1 gap-2 text-sm text-foreground">
    <div class="flex gap-1 items-center">
      <IcRoundTurnLeft class="size-3 rotate-180" />
      <div>{{ item.event.tournament_name }} {{ item.event.season }}</div>
    </div>
    <div class="flex gap-1 items-center">
      <IcRoundTurnLeft class="size-3 rotate-180" />{{ formatDates(item.event.date_start, item.event.date_stop) }}
      <Pill v-if="!item.event.date_confirmed" variant="outlined" color="info">
        {{ $t("Not confirmed") }}
      </Pill>
    </div>
    <div class="flex gap-1 items-center">
      <IcRoundTurnLeft class="size-3 rotate-180" />
      {{ item.ticket.ticket_title }}
      -
      <span class="span">{{ formatDays(item.ticket.ticket_validfrom, item.ticket.ticket_validuntil) }}</span>
    </div>
    <div class="flex gap-1 items-center">
      <IcRoundTurnLeft class="size-3 rotate-180" />{{ item.event.venue_name }} {{ item.event.city }}
    </div>
    <div v-if="payDetails?.vat_amount && (warning || reverseChargeApplied)" class="flex gap-1 items-center">
      <IcRoundTurnLeft class="size-3 rotate-180" /> {{ $t("Ticket VAT") }}{{ reverseChargeApplied ? "*" : "" }}
      <Euros :amount="payDetails.vat_amount" class="text-sm" />
    </div>
    <div v-if="warning" class="flex gap-1 items-center"><IcRoundTurnLeft class="size-3 rotate-180" />{{ warning }}</div>
    <template v-for="(message, key) in messages" :key="key">
      <div v-if="message.requirement(item)">
        <Alert :status="message.status" class="">
          {{ message.text }}
        </Alert>
      </div>
    </template>
  </div>
</template>
<script setup lang="ts">
import { useCartStore } from "@/store/cart";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { formatDays } from "@/helpers/format.js";
import { formatDates } from "@xs2event/js-lib";
import IcRoundTurnLeft from "~icons/ic/round-turn-left";
import { Pill, Alert } from "@xs2event/js-lib/components";
import Euros from "@/components/Euros.vue";

const cartStore = useCartStore();
const { t } = useI18n();

const { item } = defineProps<{
  isOpen: boolean;
  item: unknown;
}>();

const isCollect = (item: unknown) => item.type_ticket === "collect";
const isOther = (item: unknown) => item.type_ticket === "other";
const isPaperTicket = (item: unknown) => item.type_ticket === "paper" || item.type_ticket === "paperticket";

const payDetails = computed(() => cartStore.payDetails?.tickets.find((x) => x.ticket_id == item.ticket.ticket_id));

const reverseChargeApplied = computed(() => {
  return payDetails.value.reverse_charge_applied;
});

const messages: Record<
  string,
  { requirement: (item: unknown) => boolean; text: string; status: "warning" | "info" | "success" | "error" }
> = {
  paperTicket: {
    requirement: (item: unknown) => isPaperTicket(item),
    text: t(
      "Note: your booking contains paper tickets. A couple of weeks before the event these tickets will be sent to you."
    ),
    status: "warning",
  },
  collectTicket: {
    requirement: (item: unknown) => isCollect(item),
    text: t(
      "Note: your booking contains paper tickets. You or your client needs to pick up the tickets. You will receive more information from us later on."
    ),
    status: "warning",
  },
  otherTicket: {
    requirement: (item: unknown) => isOther(item),
    text: t(
      "Note: it is unclear in what form these tickets will be delivered by the supplier. You will receive more information from us later on."
    ),
    status: "warning",
  },
};

const warning = computed(() => {
  if (payDetails.value?.local_vat_number) {
    if (payDetails.value.vat_category == "low" || payDetails.value.vat_category == "high") {
      return t("Local VAT is applicable");
    } else {
      return t("Margin scheme for travel agencies is applicable");
    }
  }
});
</script>
